import { useContext } from 'react';
import SharingContext from './context';
import drawers from './Drawers';

const useFigure = (name) => {
  const ctx = useContext(SharingContext);
  const drawer = drawers[name];
  return ctx ? drawer.bind(ctx) : () => {};
};

export default useFigure;
